import SearchIcon from "@mui/icons-material/Search";
import { IconButton, TextField } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { selectSearchQuery } from "../../redux/selector";
import { actions } from "../../redux/slice";
import StatusTabs from "../StatusTabs";
import { useStyles } from "./styles";

const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const searchQuery = useSelector(selectSearchQuery);

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
        <TextField
          className={styles.search}
          placeholder={t("PLACEHOLDERS.SEARCH")}
          size="small"
          value={searchQuery}
          onChange={(event) =>
            dispatch(actions.setSearchQuery(event.target.value))
          }
          InputProps={{
            startAdornment: <SearchIcon className={styles.searchIcon} />,
          }}
        />
        <AddButton label={t("VECHILE_STATUS.ADD")} />
        <AddButton label={t("VECHILE_STATUS.ADD_TRUCK")} />
      </div>
      <StatusTabs />
    </div>
  );
};

export default ActionBar;
